"use strict";
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseVideoUrl = exports.parseChannelUrl = void 0;
var tslib_1 = require("tslib");
var url_types_1 = require("@wix/wix-vod-constants/dist/common/url-types");
var ID_REGEXP = '([\\w\\-]+)';
var CHANNEL_PATTERNS = (_a = {},
    _a[url_types_1.URL_TYPES.PLAYLIST] = [new RegExp("youtube\\.com\\/.*list=".concat(ID_REGEXP))],
    _a[url_types_1.URL_TYPES.CHANNEL] = [
        new RegExp("youtube\\.com\\/(channel|c)\\/([\\w\\-%]+)"),
    ],
    _a[url_types_1.URL_TYPES.USER_NAME] = [new RegExp("youtube\\.com\\/user\\/".concat(ID_REGEXP))],
    _a);
var VIDEO_PATTERNS = tslib_1.__assign(tslib_1.__assign({}, CHANNEL_PATTERNS), (_b = {}, _b[url_types_1.URL_TYPES.VIDEO] = [
    new RegExp("youtu\\.be\\/".concat(ID_REGEXP)),
    new RegExp("youtube\\.com\\/watch\\?.*v=".concat(ID_REGEXP)),
    new RegExp("youtube\\.com\\/(?:v|embed)\\/".concat(ID_REGEXP)),
], _b));
var findFirstMatchedId = function (regexps, url) {
    for (var _i = 0, regexps_1 = regexps; _i < regexps_1.length; _i++) {
        var regexp = regexps_1[_i];
        var res = regexp.exec(url);
        if (res) {
            return res[res.length - 1];
        }
    }
    return null;
};
var findMatch = function (patterns, url) {
    var type;
    for (type in patterns) {
        var regexps = patterns[type];
        var id = regexps ? findFirstMatchedId(regexps, url) : null;
        if (id) {
            return { id: id, type: type };
        }
    }
    return null;
};
function searchByPattern(patterns, url) {
    var result = findMatch(patterns, url);
    if (!result) {
        throw new Error("Given url doesn't match any pattern");
    }
    return result;
}
function parseChannelUrl(url) {
    return searchByPattern(CHANNEL_PATTERNS, url);
}
exports.parseChannelUrl = parseChannelUrl;
function parseVideoUrl(url) {
    return searchByPattern(VIDEO_PATTERNS, url);
}
exports.parseVideoUrl = parseVideoUrl;
//# sourceMappingURL=parse-url.js.map